import { CardComponentProps } from "@~/types/types";
import styles from "./QuantityPurchased.module.scss";
import { VIEW_GIFT_MESSAGES } from "@~/utils/events.ts";
import { useVariant } from "@~/contexts/VariantContext/VariantContext.tsx";

export function QuantityPurchased({
  product,
}: Pick<CardComponentProps, "product">) {
  const { variant } = useVariant();

  if (product.wanted === undefined) {
    return null;
  }
  const handleClick = () => {
    window.dispatchEvent(
      new CustomEvent(VIEW_GIFT_MESSAGES, {
        detail: {
          pimProductId: product.aliases.pimProductId,
          skuId: variant?.aliases?.skuId,
        },
      }),
    );
  };

  return (
    <div
      className={styles.purchasedIndicator}
      data-component="pcl-QuantityPurchased"
      onClick={handleClick}
    >
      <h2 className={styles.title}>
        {product.purchased || 0} of {product.wanted} purchased
      </h2>
    </div>
  );
}
